import { HttpErrorResponse } from '@angular/common/http';

export function readFacilityApiError(err: unknown, fallback = 'Request failed'): string {
  if (err instanceof HttpErrorResponse) {
    const body = err.error;
    if (body != null && typeof body === 'object') {
      const data = (body as {
        data?: { error?: string; explanation?: string; resolutionPath?: string };
      }).data;
      const fromData = data?.error?.trim();
      const explanation = data?.explanation?.trim();
      if (fromData && explanation) {
        return `${fromData}. ${explanation}`;
      }
      if (fromData) {
        return fromData;
      }
      const message = (body as { message?: string }).message?.trim();
      if (
        message &&
        message !== 'Bad Request' &&
        message !== 'Conflict' &&
        message !== 'Internal Server Error'
      ) {
        return message;
      }
    }
    if (typeof body === 'string' && body.trim()) {
      return body.trim();
    }
  }
  if (err instanceof Error && err.message.trim()) {
    return err.message.trim();
  }
  return fallback;
}
